import { fas } from "@fortawesome/pro-solid-svg-icons";
import { fat } from "@fortawesome/pro-thin-svg-icons";

const icons = [fas, fat];

export const faLibrary = [...icons];
